import { ICommonAPIErrorResponse } from '@/services/common/api';
import { IAnalystsConsensus, IAnalyst, IStocksDto } from './types';

async function fetchFromApi<T>(url: string): Promise<T | []> {
    try {
        const res = await fetch(url);

        if (!res.ok) {
            console.error(`[analystForecasts] Failed to fetch ${url}:`, res.statusText);
            return [];
        }

        const data = await res.json();

        if ((data as ICommonAPIErrorResponse)?.isFailed) {
            return [];
        }

        return data as T;
    } catch (error) {
        console.error(`[analystForecasts] Error fetching ${url}:`, error);
        return [];
    }
}

export const analystForecasts = {
    getAnalysts: async (ticker: string): Promise<IAnalyst[]> => {
        return await fetchFromApi<IAnalyst[]>(`/api/analysts/${ticker}`);
    },

    getConsensusOverTime: async (ticker: string): Promise<IAnalystsConsensus | []> => {
        return await fetchFromApi<IAnalystsConsensus>(`/api/stocks/consensusovertime/${ticker}`);
    },

    getIAnalystsConsensus: async (ticker: string): Promise<IAnalystsConsensus | []> => {
        const res = await fetchFromApi<IAnalystsConsensus>(`/api/analysts-consensus/${ticker}`);

        return res
    },

    getTechnologyTopStocks: async (): Promise<IStocksDto[]> => {
        return await fetchFromApi<IStocksDto[]>(`/api/stocks/top-rated?sector=technology&limit=5`);
    },
};
